import api from './client';
import { API_ENDPOINTS } from './endpoints';

export type ReminderRecipients = 'assignee' | 'assignee_and_manager';

export interface ReminderSettingsApiItem {
  _id: string;
  enabled: boolean;
  offset_days: number;
  recipients: ReminderRecipients;
  meta?: {
    status?: string;
    createdAt?: string;
    updatedAt?: string;
    updated_by?: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface ReminderSettingsResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: ReminderSettingsApiItem;
}

export interface UpdateReminderSettingsPayload {
  enabled?: boolean;
  offset_days?: number;
  recipients?: ReminderRecipients;
}

export const getReminderSettings = async (): Promise<ReminderSettingsResponse> => {
  return api.get<ReminderSettingsResponse>(API_ENDPOINTS.reminderSettings.base);
};

export const updateReminderSettings = async (
  payload: UpdateReminderSettingsPayload,
): Promise<ReminderSettingsResponse> => {
  return api.put<ReminderSettingsResponse, UpdateReminderSettingsPayload>(
    API_ENDPOINTS.reminderSettings.base,
    payload,
  );
};
